import { telemetryService } from '@locus-taxy/encore-observability/telemetry';
import { initBrowserAgent } from '@locus-taxy/encore-observability/browserAgent';
import {
  NEWRELIC_ACCOUNT_ID,
  NEWRELIC_BROWSER_APP_ID,
  NEWRELIC_BROWSER_LICENSE_KEY,
  getApiBaseUrl,
} from '../config';
import { getClientIdFromUrl } from '../hooks/useClientId';

export function initBrowserO11y() {
  const disableBrowserO11y = import.meta.env.DEV;

  if (disableBrowserO11y) {
    return;
  }

  // Initialize telemetry service - OTel
  // Get the proper base URL using clientId from URL (prod structure), fallback to generic 'client' URL
  // This is just for initialization and tracking purposes
  try {
    const clientId = getClientIdFromUrl();
    const baseUrl = clientId
      ? getApiBaseUrl(clientId)
      : getApiBaseUrl('client');
    const baseUrls = baseUrl ? [baseUrl] : [];

    telemetryService.init('encore-dashboard', __APP_VERSION__, baseUrls);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      '[encore-o11y] Failed to initialize browser telemetry:',
      error instanceof Error ? error.message : error
    );
    // Skip/disable telemetry on error - continue without telemetry initialization
  }

  // Initialize browser agent - New Relic
  const [accountId, browserApplicationId, licenseKey] = [
    NEWRELIC_ACCOUNT_ID,
    NEWRELIC_BROWSER_APP_ID,
    NEWRELIC_BROWSER_LICENSE_KEY,
  ].map(value => value.trim());

  const browserAgent = initBrowserAgent({
    accountId,
    browserApplicationId,
    licenseKey,
  });

  if (browserAgent) {
    browserAgent.setApplicationVersion(__APP_VERSION__);
  }
}
